// ** I18n Imports
import i18n from 'i18next'
import Backend from 'i18next-xhr-backend'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

// ** Boot language via the shared locale cascade:
// account (post-login, strongest) -> ?lang= -> navigator.language -> de.
// Pre-login this picks the browser/URL language; once an account is stored
// it wins. Runtime re-application on fresh login/account switch happens in
// Login.js (on success) and views/apps/email/index.js (on mount).
import { resolveInitialLng } from '@src/utility/localeCascade'

i18n

  // Enables the i18next backend
  .use(Backend)

  // Enable automatic language detection
  .use(LanguageDetector)

  // Enables the hook initialization module
  .use(initReactI18next)
  .init({
    lng: resolveInitialLng(), // cascade: account -> ?lang= -> navigator.language -> de
    backend: {
      /* translation file path */
      loadPath: `${process.env.PUBLIC_URL}/assets/data/locales/{{lng}}.json`
    },
    fallbackLng: 'en',
    debug: false,
    keySeparator: false,
    react: {
      useSuspense: false
    },
    interpolation: {
      escapeValue: false,
      formatSeparator: ','
    }
  })

const updateDocumentLanguage = language => {
  document.documentElement.lang = language
  document.title = 'Pronto Posto'
}
i18n.on('languageChanged', updateDocumentLanguage)
updateDocumentLanguage(i18n.language || resolveInitialLng())

export default i18n
